module.exports = __webpack_public_path__ + "img/hakhak.7c7183f6.webp";